/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }

  contacts(params = {}) {
    return axios.get(`${this.url}/contacts`, {
      params,
    });
  }

  conversations(params = {}, config = {}) {
    return axios.get(`${this.url}/conversations`, {
      params,
      ...config,
    });
  }

  messages(params = {}) {
    return axios.get(`${this.url}/messages`, {
      params,
    });
  }

  suggestions(params = {}, config = {}) {
    return axios.get(`${this.url}/suggestions`, {
      params,
      ...config,
    });
  }

  emailRecipients(params = {}, config = {}) {
    return axios.get(`${this.url}/email_recipients`, {
      params,
      ...config,
    });
  }

  external(params = {}) {
    return axios.get(`${this.url}/external`, {
      params,
    });
  }

  // Conta la ricerca lanciata dalla persona: mai il testo cercato.
  launched(scope) {
    return axios.post(`${this.url}/launched`, { scope });
  }

  externalImport(data = {}) {
    return axios.post(`${this.url}/external_import`, data);
  }
}

export default new SearchAPI();
